/*
 * @Author: 刘小博
 * @Date: 2023-02-07 14:39:08
 * @LastEditTime: 2023-02-21 14:19:23
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\behavior-manage\performance-appraisal-manage\modules\attractInvestmentCheckRouter.js
 * 招商绩效考核
 */
const attractInvestmentCheckRouter = [
  // 效绩考核 1 月度考核 2 周期考核 3 年度考核
  {
    path: '/behaviorManage/performance-assess/:meta_type',
    name: 'behaviorManagePerformanceAssess',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManagePerformanceAssess" */
      //   '@/views/behaviorManage/jiuxin/PerformanceAssess.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManagePerformanceAssess" */
        '@/views/behavior-manage/performance-appraisal-manage/attract-investmen-check/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '招商绩效考核', //二级菜单
      isMoreMeta: true,
      1: {
        title: '月度考核',
      },
      2: {
        title: '周期考核',
      },
      3: {
        title: '年度考核',
      },
    },
  },
  // 效绩考核详情  meta_type 月度 季度 年度 type 1招商代表 2地区经理
  {
    path: '/behaviorManage/performance-assess-details/:meta_type/:type/:id/:scene_num/:year/:selfSupport/:month',
    name: 'behaviorManagePerformanceAssessDetails',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManagePerformanceAssess" */
      //   '@/views/behaviorManage/jiuxin/PerformanceAssessDetails.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManagePerformanceAssess" */
        '@/views/behavior-manage/performance-appraisal-manage/attract-investmen-check/Detail.vue'
      ),   //新文件迁移
    meta: {
      SecondaryMenu: '招商绩效考核', //二级菜单
      isMoreMeta: true,
      1: {
        title: '月度详情',
        breadcrumb: [
          {
            title: '月度考核',
            name: 'behaviorManagePerformanceAssess',
          },
        ],
      },
      2: {
        title: '周期详情',
        breadcrumb: [
          {
            title: '周期考核',
            name: 'behaviorManagePerformanceAssess',
          },
        ],
      },
      3: {
        title: '年度详情',
        breadcrumb: [
          {
            title: '年度考核',
            name: 'behaviorManagePerformanceAssess',
          },
        ],
      },
    },
  },
  // 分数修改记录
  {
    path: '/behaviorManage/amend-record/:meta_type/:selfSupport',
    name: 'behaviorManageAmendRecord',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageAmendRecord" */
      //   '@/views/behaviorManage/jiuxin/AmendRecord.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageAmendRecord" */
        '@/views/behavior-manage/performance-appraisal-manage/attract-investmen-check/ScoreModifyRecord.vue'
      ),  //新迁移文件
    meta: {
      SecondaryMenu: '招商绩效考核', //二级菜单
      isMoreMeta: true,
      1: {
        title: '分数修改记录',
        breadcrumb: [
          {
            title: '月度考核',
            name: 'behaviorManagePerformanceAssess',
          },
        ],
      },
      2: {
        title: '分数修改记录',
        breadcrumb: [
          {
            title: '周期考核',
            name: 'behaviorManagePerformanceAssess',
          },
        ],
      },
      3: {
        title: '分数修改记录',
        breadcrumb: [
          {
            title: '年度考核',
            name: 'behaviorManagePerformanceAssess',
          },
        ],
      },
    },
  },
  // 设置周计划指标
  {
    path: '/behaviorManage/set-weekly/:meta_type/:selfSupport',
    name: 'behaviorManageSetWeekly',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageSetWeekly" */
      //   '@/views/behaviorManage/jiuxin/SetWeekly.vue'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageSetWeekly" */
        '@/views/behavior-manage/performance-appraisal-manage/attract-investmen-check/DesignWeeklyPlanIndex.vue'
      ),  //新迁移文件
    meta: {
      SecondaryMenu: '招商绩效考核', //二级菜单
      isMoreMeta: true,
      1: {
        title: '设置周计划指标',
        breadcrumb: [
          {
            title: '月度考核',
            name: 'behaviorManagePerformanceAssess',
          },
        ],
      },
      2: {
        title: '设置周计划指标',
        breadcrumb: [
          {
            title: '周期考核',
            name: 'behaviorManagePerformanceAssess',
          },
        ],
      },
      3: {
        title: '设置周计划指标',
        breadcrumb: [
          {
            title: '年度考核',
            name: 'behaviorManagePerformanceAssess',
          },
        ],
      },
    },
  },
  // 导入产品知识培训
  {
    path: '/behaviorManage/import-goods-exam/:meta_type',
    name: 'behaviorManageImportGoodsExam',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageAmendRecord" */
      //   '@/views/behaviorManage/jiuxin/importGoodsExam.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageAmendRecord" */
        '@/views/behavior-manage/performance-appraisal-manage/attract-investmen-check/Import.vue'
      ),   //新文件迁移
    meta: {
      SecondaryMenu: '自营绩效考核', //二级菜单
      isMoreMeta: true,
      1: {
        title: '导入产品知识培训',
        breadcrumb: [
          {
            title: '月度考核',
            name: 'behaviorManagePerformanceAssess',
          },
        ],
      },
      2: {
        title: '导入产品知识培训',
        breadcrumb: [
          {
            title: '周期考核',
            name: 'behaviorManagePerformanceAssess',
          },
        ],
      },
      3: {
        title: '导入产品知识培训',
        breadcrumb: [
          {
            title: '年度考核',
            name: 'behaviorManagePerformanceAssess',
          },
        ],
      },
    },
  },
]
export default attractInvestmentCheckRouter
